// src/routes/dispatcherRoutes.js
import AuthRoute from '../modules/Base/Auth/components/AuthRoute';

import Home from '../modules/Dispatcher/index.jsx';
import AccessManagement from '../modules/Dispatcher/AccessManagement/AccessManagement';
import GiveAccess from '../modules/Dispatcher/GiveAccess/GiveAccess.js';
import RouteDetails from '../modules/Dispatcher/RouteDetails/RoutesDetails';
import Undelivered from '../modules/Dispatcher/Undelivered/Undelivered.js';
import FiscalChecks from '../modules/Dispatcher/FiscalChecks/FiscalChecks.jsx';


const dispatcherRoutes = [
  {path: '/dispatcher',                   element: (<AuthRoute requiredPermissions={['pages:dispatcher:view:any']}><Home /></AuthRoute>),},
  {path: '/dispatcher/accessmanagement',  element: (<AuthRoute requiredPermissions={['pages:dispatcher:view:any']}><AccessManagement /></AuthRoute>),},
  {path: '/dispatcher/giveaccess',        element: (<AuthRoute requiredPermissions={['pages:dispatcher:view:any']}><GiveAccess /></AuthRoute>),},
  {path: '/dispatcher/routesdetails',     element: (<AuthRoute requiredPermissions={['pages:dispatcher:view:any']}><RouteDetails /></AuthRoute>),},
  {path: '/dispatcher/undelivered',       element: (<AuthRoute requiredPermissions={['pages:dispatcher:view:any']}><Undelivered /></AuthRoute>),},
  {path: '/dispatcher/fiscalchecks',      element: (<AuthRoute requiredPermissions={['pages:dispatcher:view:any']}><FiscalChecks /></AuthRoute>),},

];

export default dispatcherRoutes;
